import { useEffect } from 'react'
import { useSessionStorage } from 'react-use'
import { enableUpdates } from './updatesManager'
import { log } from '@sketch/utils'
import { trackEvent } from 'modules/analytics'
import { MINIMUM_HIDDEN_HOURS } from 'utils/hooks/useVisibilityTracker'
import { useHistory } from 'react-router'
import { AugmentedHistory } from 'app-wide-types'

export const useForceAppRefresh = () => {
  const [hoursHidden, setHoursHidden] = useSessionStorage<number>('hoursHidden')
  // we don't really want to use `as AugmentedHistory` (particularly `as` part) here
  // but this is the only place within the whole app where we actually use AugmentedHistory type
  // and rewriting all `useHistory` hooks didn't seem worthy neither we wanted to expose augmented props
  // to other components.
  const history = useHistory() as AugmentedHistory

  useEffect(() => {
    enableUpdates({
      history,
      onForceRefreshed: () => {
        log('Sketch Cloud was updated to the latest version')
        if (hoursHidden >= MINIMUM_HIDDEN_HOURS) {
          trackEvent('App Force Refresh', { hoursHidden })
          setHoursHidden(0)
        }
      },
    })
  })
}
